import { useMutation, useQueryClient } from '@tanstack/react-query';
import { adminFetch } from '@/lib/apiClient';
import { throwFromResponse } from '../lib/apiErrorMessage';
import type { MemberStatus } from './useAdminUsersQuery';
import { userDetailQueryKey } from './useUserDetailQuery';

export interface UserStatusPayload {
  status: MemberStatus;
  reason?: string | undefined;
}

export const useUserStatusMutation = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ userId, payload }: { userId: string; payload: UserStatusPayload }) => {
      const res = await adminFetch(`/api/admin/v1/users/${userId}/status`, {
        method: 'PATCH',
        body: JSON.stringify(payload),
      });
      if (!res.ok) await throwFromResponse(res, '회원 상태 변경에 실패했습니다.');
    },
    onSuccess: (_data, { userId }) => {
      void qc.invalidateQueries({ queryKey: ['admin', 'users'] });
      void qc.invalidateQueries({ queryKey: userDetailQueryKey(userId) });
    },
  });
};
